import { render, staticRenderFns } from "./ReportGeneralView.vue?vue&type=template&id=231c49f2&"
import script from "./ReportGeneralView.vue?vue&type=script&lang=ts&"
export * from "./ReportGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231c49f2')) {
      api.createRecord('231c49f2', component.options)
    } else {
      api.reload('231c49f2', component.options)
    }
    module.hot.accept("./ReportGeneralView.vue?vue&type=template&id=231c49f2&", function () {
      api.rerender('231c49f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/reports/ReportGeneralView.vue"
export default component.exports